import styled from 'styled-components';
import { Divider } from 'ui/divider';
import { body2, colors, heading4, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const customSpacing = {
  p20: pxToRem(20),
};
export const StyledTextHeader = styled.div`
  ${heading4};
`;

export const StyledExperimentsSummaryInfoBanner = styled.div`
  padding: ${spacing.plusHalf} ${spacing.base} 0 ${spacing.base};
  display: flex;
  align-items: flex-start;
`;

export const StyledExperimentsTextContainer = styled.div<{ includesSubText: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: ${({ includesSubText }) =>
    includesSubText
      ? `0 0 ${customSpacing.p20} ${spacing.base}`
      : `${spacing.threeQuarter} 0 ${spacing.double} ${spacing.base}`};
`;

export const StyledExperimentSummarySecondaryText = styled.div`
  ${body2}
  padding-top: ${spacing.threeEights};
`;

export const StyledExperimentStatusBadge = styled.div<{ color: string; includesSubText: boolean }>`
  background: ${({ color }) => color || colors.grey10};
  border-radius: 4px;
  width: 56px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: ${({ includesSubText }) => (includesSubText ? `0 0 ${spacing.plusHalf} 0` : `0 0 0 0`)};
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
  background: ${colors.grey15};
`;

export const StyledTableHeaderSectionWithToggle = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${spacing.base} ${spacing.base};
`;

export const HighlightVariantWinnerWrapper = styled.div`
  width: 100%;
  overflow: auto;

  div > div > div[data-is-winner='true'] {
    border-top: ${spacing.single} solid ${colors.green100};
    border-bottom: ${spacing.single} solid ${colors.green100};
  }

  div > div > div[data-is-winner='true']:first-of-type {
    border-left: ${spacing.single} solid ${colors.green100};
    border-top: ${spacing.single} solid ${colors.green100};
  }
  div > div > div[data-is-winner='true']:last-of-type {
    border-right: ${spacing.single} solid ${colors.green100};
    border-bottom: ${spacing.single} solid ${colors.green100};
  }

  div > div:last-of-type > div[data-is-winner='true']:first-of-type {
    border-radius: 0 0 0 ${spacing.half};
  }

  div > div:last-of-type > div[data-is-winner='true']:last-of-type {
    border-radius: 0 0 ${spacing.half} 0;
  }
`;
